export const getFullName = (firstName?: string, lastName?: string) => {
  if (firstName && lastName) {
    return [firstName, lastName].join(' ')
  }

  return firstName || lastName || ''
}
